module.exports = __webpack_public_path__ + "static/media/le-specs-Opaque-Red-Silver-Mirror-X-Adam-Selman-The-Last-Lolita_thumb.9d980adc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/some-extra- womenswear- product-shots/thumbs/le-specs-Opaque-Red-Silver-Mirror-X-Adam-Selman-The-Last-Lolita_thumb.png
// module id = 327
// module chunks = 0